document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('[data-animate]');

  targets.forEach(el => {
    if (el.dataset.animDuration) {
      el.style.setProperty('--anim-duration', el.dataset.animDuration);
    }
    if (el.dataset.animDelay) {
      el.style.setProperty('--anim-delay', el.dataset.animDelay);
    }
  });

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  targets.forEach(el => observer.observe(el));
});